<template>
  <div class="container_left">
    <!-- <el-card class="box-card">
      <el-row>
        <el-col :span="12">
          <div class="real_account" :class="$store.state.listType==1?'is-active':''" @click="_changeAcc(1)">
            <span class="icon_acc"><img src="@/assets/image/real_icon.png" /></span>
            <span class="icon_text">真实账户</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="real_account demo_account" :class="$store.state.listType==0?'is-active':''" @click="_changeAcc(0)">
            <span class="icon_acc"><img src="@/assets/image/demo_icon.png" /></span>
            <span class="icon_text">模拟账户</span>
          </div>
        </el-col>
      </el-row>
    </el-card> -->
    <el-card class="box-card left-main">
      <el-row>
        <el-col :span="24">
          <el-menu ref="leftMenu" :default-active="$route.path" :default-openeds="[$store.state.leftActive]" class="el-menu-vertical-demo" @open="handleOpen" :unique-opened="true">
            <template v-for="(item,index) in leftList">

              <el-menu-item ref="leftHome" :index="item.children[0].path" @click="_routerChange(item.children[0].path,'home')" class="_index_link" v-if="index==0">
                <i :class="item.meta.icon"></i>
                <span slot="title">{{item.meta.title}}</span>
              </el-menu-item>
              <el-submenu :index="item.children[0].path" v-if="index>0&&item&&index<7">
                <template slot="title">
                  <i :class="item.meta.icon"></i>
                  <span slot="title">{{item.meta.title}}</span>
                </template>
                <el-menu-item-group v-if="index>0">
                  <template v-for="(childrenItem,childrenIndex) in item.children" v-if="!childrenItem.meta.hide && ((!childrenItem.meta.pathWay) || ($store.state.listType==0?childrenItem.meta.pathWay=='3-1'||childrenItem.meta.pathWay=='3-3'||childrenItem.meta.pathWay=='4-1':index=='3'?$store.getters.authItem.indexOf(childrenItem.meta.title)>=0?1:0:1))">
                    <el-menu-item @click="_routerChange(childrenItem.path)" :index="childrenItem.path">{{childrenItem.meta.title}}</el-menu-item>
                  </template>
                </el-menu-item-group>
              </el-submenu>
              <!-- <el-menu-item :index="item.children[0].path" @click="_routerChange(item.children[0].path,'upGrade')" class="_index_link_up" v-if="item&&index===6">
                <i :class="item.meta.icon"></i>
                <span slot="title">{{item.meta.title}}</span>
              </el-menu-item> -->
              <el-menu-item :index="item.children[0].path" @click="_routerChange(item.children[0].path,'activity')" class="_index_link_up" v-if="item&&index===7">
                <i :class="item.meta.icon"></i>
                <span slot="title">{{item.meta.title}}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-col>
      </el-row>
    </el-card>
    <bind-box @changeAcc="_changeAcc"></bind-box>
  </div>
</template>
<script>
  import { base64 } from '@/utils'
  import { login, accountinfo } from '@/api'
  import bindBox from "@/views/common/bindBox";
  export default {
    data() {
      return {
        leftList: [],
        currentActive: 0,
        changeIndex: 0
      }
    },
    components: {
      bindBox
    },
    methods: {
      handleOpen(key, keyPath) {
        this.$store.commit('setLeftActive', key)
      },
      //切换账户
      _changeAcc(i) {

        // 当前用户的开户情况 0只有模拟 1只有真实 2都有
        if (i != this.$store.state.listType && this.changeIndex === 0) {
          this.changeIndex = 1
          let params = {
            type: i
          }
          login.switch(params).then(res => {
            if (res.IsSuccess) {
              $('._index_link').trigger('click')
              this.$store.commit('setListType', i)
              this.$refs['leftMenu'].close(this.$store.state.leftActive)
              this.leftList = this.$store.getters.currenLeftList
              let userInfo = res.Data.jfSimulatorAccount ? res.Data.jfSimulatorAccount : res.Data.jfAccount
              this.$store.commit('setUserInfo', userInfo)
            } else {
              if (i == 1) {
                this.$store.commit('setBindBoxStatue', 1)
              } else {
                this.$store.commit('setBindBoxStatue', 2)
              }
            }
            setTimeout(() => {
              this.changeIndex = 0
            }, 300)

          })
        }
      },
      // left_postion
      _leftPostion() {
        const winHeight = window.innerHeight
        const leftOffset = $('.left-main').offset().top;
        $(window).scroll(function() {
          const scrollH = $(window).scrollTop();
          const leftHeight = $('.left-main').height();
          const rightWrap = $('.container').height();
          if (rightWrap > leftHeight) {
            if (scrollH >= leftOffset) {
              $('.left-main').css({ 'position': 'fixed', 'top': '5px' })
            } else {
              $('.left-main').css({ 'position': 'static' })
            }
          }
        });
      },
      // 生成左侧list
      _createLeftList() {
        //this.$store.dispatch('getFundsAuth')
        this.$store.commit('setLeftList')
      },
      _routerChange(path, flag) {
        if (flag === 'home' || flag === 'upGrade') {
          this.$refs['leftMenu'].close(this.$store.state.leftActive)
          if (flag === 'home') {
            this.$store.commit('setLeftActive', 1)
          } else {
            this.$store.commit('setLeftActive', 7)
          }
        }
        if (path != '/deposit') {
          this.$router.push({
            path
          })
        }else{
          maidian({ eventname: 'd1', eventdescribe: '入金意向', eventtype: 'click' })
          accountinfo.getIdentityInfo().then(res => {
            if (res.IsSuccess) {
              if(res.Data.jfUser.authenticationMethod == 0){
                this.$confirm('为保证您的资金安全，请您先完成基础认证，感谢您的配合！', '温馨提示', {
                  distinguishCancelAndClose: true,
                  confirmButtonText: '实名认证',
                  cancelButtonText: '取消'
                }).then(() => {
                  //点击确定 前往实名认证
                  this.$router.push({
                    name: 'basicMsg'
                  })
                })
              }else{
                this.$router.push({
                  path: '/deposit'
                })
              }
            }
          })
        }
      },
    },
    mounted() {
      this._leftPostion()
      this._createLeftList()
      this.leftList = this.$store.getters.currenLeftList
    },
    watch: {
      '$store.state.fundsAuth'(newV, oldV) {
        this.leftList = this.$store.getters.currenLeftList
      },
      '$route'(newV, oldV) {
        let pName = newV.matched[0].meta.title
        let sName = newV.matched[1].meta.title
        let pathWay = newV.matched[0].meta.pathWay
        let breadParam = {
          oB: pName,
          topPath: pathWay,
          children: [{
            name: sName,
            path: newV.path
          }]
        }
        this.$store.commit('setBread', breadParam);
      }
    },
  }
</script>

<style lang="scss">
  @import '~scss/common/left.scss';
</style>


// WEBPACK FOOTER //
// src/views/common/left.vue